import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Row, Col, Button, Input, Modal, Empty } from 'antd';
import icon from './img/1.png'
import time from './img/time.png'
import './ClueManage.css'
import ClueLook from './ClueLook'
import { connect } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";
import * as utils from "../../../utils/index";
import Item from 'antd/lib/list/Item';


const { TextArea } = Input;

class ClueManageList extends Component {
    static defaultProps = {
        newSecondSelectColor:"#0050B3"
    }
    static propTypes = {
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        submitTime: PropTypes.string.isRequired,
        status: PropTypes.number.isRequired,
        isinterview: PropTypes.number.isRequired,
        contacts: PropTypes.string.isRequired,
        submitter: PropTypes.string.isRequired,
        review_content: PropTypes.string.isRequired,
        clueId: PropTypes.object.isRequired,
        pictureData: PropTypes.array.isRequired,
        videoData: PropTypes.array.isRequired,
        attachmentFileData: PropTypes.array.isRequired,
    }
    constructor(props) {
        super(props);
        this.state = {
            adoptVisible: false,
            abandonVisible: false,
            adoptValue: "",
            abandonValue: ""
        };
    }
    clickLook = () => {
        console.log(this)
        console.log(this.props.clueId)
        this.clueLook.showModal()
        this.props.getClueIds();
        this.props.getPictures();
        this.props.getVideos();
        this.props.getAttachments();
    }
    //采用
    adoptOk = e => {
        this.props.getClueadoptDatas(this.props.id, this.state.adoptValue)
        this.setState({
            adoptVisible: false,
        });
    };

    adoptCancel = e => {
        this.setState({
            adoptVisible: false,
        });
    };
    adopt = () => {
        this.setState({
            adoptVisible: true,
        });
    }
    //弃用
    abandonOk = e => {
        this.props.getClueabandonDatas(this.props.id, this.state.abandonValue)
        this.setState({
            abandonVisible: false,
        });
    };

    abandonCancel = e => {
        this.setState({
            abandonVisible: false,
        });
    };
    abandon = () => {
        this.setState({
            abandonVisible: true,
        });
    }
    render() {
        let status = this.props.status;
        let isinterview = this.props.isinterview;
        let statusContent
        let statusOperation
        if (status === 0) {
            statusContent = (
                <div className="statusStyle" style={{color:"#5a63e6"}}>
                    已提交
                </div>
            )
        } else if (status === 1 && isinterview === 1) {
            statusContent = (
                <div className="statusStyle2">
                    已采用（已转为任务）
                </div>
            )

        } else if (status === 1) {
            statusContent = (
                <div style={{backgroundColor:"#f4f6fc"}} className="statusStyle">
                    已采用
                </div>
            )
        } else if (status === 2) {
            statusContent = (
                <div style={{backgroundColor:"#f4f6fc"}} className="statusStyle">
                    已弃用
                </div>
            )
        }
        // 操作
        if (status === 0) {
            console.log(this.props)
            statusOperation = (
                <div>
                    <Button size="small" onClick={this.clickLook}>查看</Button>
                    <span style={{ margin: "0px 5px" }}>
                        <Button size="small" type="primary" onClick={this.adopt} style={{backgroundColor:this.props.newSecondSelectColor,borderColor:this.props.newSecondSelectColor}}>采用</Button>
                    </span>
                    <Button size="small" type="primary" onClick={this.abandon} style={{backgroundColor:this.props.newSecondSelectColor,borderColor:this.props.newSecondSelectColor}}>弃用</Button>
                </div>
            )
        }
        else if (status === 1 && isinterview !== 1 && this.props.currentUser.roleCodes.indexOf("xsbj") === -1) {   //判断是否有管理权限
            statusOperation = (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div>
                        <Button size="small" onClick={this.clickLook}>查看</Button>
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                        <Button size="small" type="primary" onClick={() => this.props.newsClueAdd()} style={{backgroundColor:this.props.newSecondSelectColor,borderColor:this.props.newSecondSelectColor}}>转为任务</Button>
                    </div>
                </div>
            )
        }
        else if (status === 1 && isinterview === 1) {
            statusOperation = (
                <div style={{ marginLeft: "5px" }}>
                    <Button size="small" onClick={() => this.props.newsClueView()}>查看任务</Button>
                </div>
            )
        } else if (status === 2) {
            statusOperation = (
                <div>
                    <Button size="small" onClick={this.clickLook}>查看</Button>
                </div>
            )
        }

        return (
            <div>
                <div
                    style={{ borderBottom: "1px solid #ccc", padding: "15px" }}
                    className="clueMouseEnter"
                >
                    <Row justify="start">
                        {/* 全选 */}
                        <Col span={10} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            color: "#2a3a6b",
                            fontSize: "16px",
                            fontWeight: 400,
                            cursor: "pointer"
                        }}
                            onClick={this.clickLook}
                        >
                            <img style={{ marginRight: "15px", width: "48px", height: "48px" }} src={icon} alt="" />
                            {this.props.title}
                        </Col>
                        <Col span={4} style={{ textAlign: "center", color: "rgb(135, 146, 179)", fontWeight: "bold", fontSize: "15px", lineHeight: "48px" }}>
                            <img src={time} style={{ marginRight: "5px" }} alt="" />
                            {this.props.submitTime}
                        </Col>
                        <Col span={4} style={{ textAlign: "center", lineHeight: "48px" }}>
                            <div style={{ marginBottom: "8px" }}></div>
                            {statusContent}
                        </Col>
                        <Col span={6} style={{ textAlign: "center", lineHeight: "48px" }}>
                            {statusOperation}
                        </Col>
                        <Modal
                            centered
                            title="采用原因（注：必填项）"
                            visible={this.state.adoptVisible}
                            onOk={this.adoptOk}
                            onCancel={this.adoptCancel}
                            width="300px"
                            bodyStyle={{ height: "140px" }}
                        >
                            <TextArea rows={4} value={this.state.adoptValue} onChange={(e) => this.adoptChange(e)} />
                        </Modal>
                        <Modal
                            centered
                            title="弃用原因（注：必填项）"
                            visible={this.state.abandonVisible}
                            onOk={this.abandonOk}
                            onCancel={this.abandonCancel}
                            width="300px"
                            bodyStyle={{ height: "140px" }}
                        >
                            <TextArea rows={4} value={this.state.abandonValue} onChange={(e) => this.abandonChange(e)} />
                        </Modal>
                    </Row>
                </div>
                                    <ClueLook
                                        key={this.props.id}
                                        ref={(c)=>this.clueLook=c}
                                        key={this.props.id}
                                        id={this.props.id}
                                        title={this.props.title}
                                        status={this.props.status}
                                        isinterview={this.props.isinterview}
                                        contacts={this.props.contacts}  //联系人
                                        contactsWay={this.props.contactsWay}  //联系方式
                                        review_submitter={this.props.review_submitter}  //操作人
                                        review_content={this.props.review_content}  //采用原因
                                        submitter={this.props.submitter}
                                        submitTime={
                                            this.props.submitTime
                                        }
                                        clueId={this.props.clueId}
                                        pictureData={this.props.pictureData}
                                        videoData={this.props.videoData}
                                        attachmentFileData={this.props.attachmentFileData}
                                        newSecondSelectColor={this.props.newSecondSelectColor}
                                        currentUser={this.props.currentUser}
                                        newsClueAdd={this.props.newsClueAdd}
                                        newsClueView={this.props.newsClueView}
                                        abandon={()=>this.abandon()}
                                        adopt={()=>this.adopt()}
                                    />
            </div>
        );
    }
    adoptChange(e) {
        this.setState({
            adoptValue: e.target.value
        })
    }
    abandonChange(e) {
        this.setState({
            abandonValue: e.target.value
        })
    }
}
function mapStateToProps(state) {
    // 将state中的systeReducer的config放入props中,使实例对象能操作
    // console.log(state)
    return {
        config: state.systemReducer.config,
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(ClueManageList);